export default {
  rollover: {
    title: 'رول اوور',
    detailsTitle: 'رول اوور کی تفصیلات',
    all: 'تمام',
    allStats: 'تمام حالتیں',
    select: 'منتخب کریں',
    rolloverType: 'رول اوور کی قسم',
    amount: 'رقم',
    source: 'ذریعہ',
    wallet: 'والیٹ',
    current: 'موجودہ',
    wagered: 'شرط لگائی گئی',
    required: 'مطلوب',
    progress: 'پیش رفت',
    loading: 'لوڈ ہو رہا ہے...',
    noData: 'کوئی ڈیٹا نہیں',
    noMoreData: 'مزید ڈیٹا نہیں',
    state: 'حالت',
    type: 'قسم',
    createdOn: 'بنایا گیا',
    wageringRequirement: 'شرط کی ضرورت',
    currency: 'کرنسی',
    wagerRequired: 'مطلوبہ شرط',
    wagerCompleted: 'مکمل شرط',
    cash: 'کیش',
    bonus: 'بونس',
  },
};
